import React from 'react';
import './invoiceTemplates-view.css';
import '../../styles/page-common.css';
import '../../styles/list-glass.css';
import { Redirect, Link } from "react-router-dom";
import SpinnerView from '../../components/spinner/spinner-view';

const COLS = '1fr 0.5fr';

class HomeView extends React.Component {

  state = { search: '' }

  componentDidMount() {
    this.props.getInvoiceTemplates();
  }

  handleSearch = (value) => this.setState({ search: value });

  render() {
    if (this.props.user && !this.props.user._id) {
      return <Redirect to='/' />
    }

    const all = this.props.invoiceTemplates || [];
    const items = all.filter(p => {
      if (!this.state.search) return true;
      return (p.invoiceTemplateName || '').toLowerCase().includes(this.state.search.toLowerCase());
    });

    const initials = (nm) => (nm || '?').split(' ').filter(Boolean).slice(0, 2).map(w => w[0]).join('').toUpperCase();
    const avColor = (nm) => { let h = 0; for (let c = 0; c < (nm || '').length; c++) h = (h * 31 + nm.charCodeAt(c)) % 6; return h; };

    return (
      <div
        className="content-wrapper p-2"
        style={{ ['--list-accent']: '#0DA1B2', ['--list-accent-dark']: '#067886' }}
      >
        <SpinnerView showSpinner={this.props.loading} />

        <div className="gl-hero">
          <div className="gl-hero-row">
            <div>
              <div className="gl-hero-title">Invoice Templates</div>
              <div className="gl-hero-sub">{all.length} template{all.length === 1 ? '' : 's'}</div>
            </div>
            <div className="gl-hero-actions">
              <Link className="gl-hero-btn solid" to="/invoiceTemplate/new">
                <i className="fas fa-plus"></i> New template
              </Link>
            </div>
          </div>
        </div>

        <div className="gl-filter">
          <div className="gl-search">
            <i className="fas fa-magnifying-glass"></i>
            <input placeholder="Filter templates…" value={this.state.search} onChange={(e) => this.handleSearch(e.target.value)} />
          </div>
        </div>

        <div className="gl-list" style={{ ['--gl-cols']: COLS }}>
          <div className="gl-list-head">
            <div>Template</div>
            <div></div>
          </div>

          {items.length === 0 && <div className="gl-empty">No invoice templates yet.</div>}

          {items.map(p => (
            <Link key={p._id} to={"/invoiceTemplate/" + p._id} style={{ textDecoration: 'none' }}>
              <div className="gl-row neutral">
                <div className="gl-client">
                  <div className={`gl-av gl-av-${avColor(p.invoiceTemplateName)}`}>{initials(p.invoiceTemplateName)}</div>
                  <div style={{ minWidth: 0 }}>
                    <div className="name">{p.invoiceTemplateName || 'Untitled template'}</div>
                  </div>
                </div>
                <div className="gl-actions">
                  <span className="gl-icon-btn"><i className="fas fa-arrow-right"></i></span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    );
  }
}

export default HomeView;
